// @flow
import type { FilesActionType } from './actions';

export const initialState: FilesStateType = [];

export default (state: FilesStateType = initialState, action: FilesActionType) => {
  switch (action.type) {
    case 'SET_FILES':
      return action.payload.files;
    default:
      return state;
  }
};

export type FileType = {
  characteristics?: Object,
  content?: Object,
  contentSize?: number,
  creatorOuid: string,
  customerOuid: string,
  dateTimeCreate: number,
  dateTimeLastModif: number,
  fileName: string,
  isCustomerVisible: boolean,
  mediaType: string,
  modifierOuid: string,
  ouid: string,
  status: string,
  storeId?: string,
  version: number,
};

export type FilesStateType = FileType[];
